export const getMfaError = (response) =>
  response?.screen?.properties?.customHTML?.value?.nextstep?.errors?.errorDetails?.error;
